/**
 *
 * Copyright (c) 2020, Vathos GmbH
 *
 * All rights reserved.
 */
import axios from 'axios';

const appUrl = process.env.VUE_APP_BLOBS_URL;

const filesApiFactory = (endpoint)=> {
  const api = {};
  api.upload = async (data)=>{
    const url = `${appUrl}/${endpoint}`;
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
      },
    };
    return await axios.post(url, data, config);
  };
  api.edit = async (id, data)=>{
    const url = `${appUrl}/${id}`;
    return await axios.patch(url, data);
  };
  return api;
};

export default filesApiFactory;
